import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {VehicleLocation} from '../../../commons/models/domain/VehicleLocation';
import {FullAddressPipe} from '@commons/pipes/full-address.pipe';
import {CountryCodeService} from '@commons/services/country.code/country-code.service';

@Component({
  selector: 'tk-vehicle-location',
  styleUrls: ['./vehicle-location.component.less'],
  templateUrl: './vehicle-location.component.html'
})
export class VehicleLocationComponent implements OnInit, OnChanges {
  @Input()
  public location?: VehicleLocation;

  /**
   * adres do pkazania
   */
  public address = '';

  /**
   * transformer
   */
  private $fullAddressPipe = new FullAddressPipe();

  private formatAddress() {
    this.address = '';
    if (this.location) {
      this.location.Cr = this.$countryCodeService.getCode(this.location.Cr);
      const newAddress = this.$fullAddressPipe.transform(this.location);
      this.address = newAddress.length > 0 ? newAddress : '';
    }
  }

  ngOnInit() {

    // na podstawie dostepnych parametrow nalezy opacowac co i jak pokazac = standaryzacja
    this.formatAddress();

  }

  ngOnChanges(changes: SimpleChanges) {
    // gdy nastapila zmiana wartosc to takze przetwazamy
    this.formatAddress();
  }


  constructor(
    private $countryCodeService: CountryCodeService
  ) {
  }

}
